export default {
    source(state) {
        return state.source;
    },
    workspaceSources(state) {
        return state.workspaceSources;
    },
    sourceForSelect(state) {
        return state.workspaceSources.map(source => ({
            id: source.id,
            text: source.name
        }));
    }
}